import { isMock } from '../config'
import { peticionesMock } from './mock'
import { peticionesReal } from './real'
import type { PeticionesService } from './types'

export const peticionesService: PeticionesService = isMock('peticiones') ? peticionesMock : peticionesReal
export type { EntryPreference, GuestCommentInput, GuestRequest, GuestRequestComment, GuestRequestFormType, GuestRequestInput, GuestRequestMilestone, GuestRequestStatus, GuestRequestType, PeticionesService } from './types'
